// Configuration for Category Sorting and Icons
export const CATEGORY_CONFIG = {
    // --- TOOLS (Gereedschap) - 12 Categories ---

    // 1. Algemeen
    'Algemeen Handgereedschap': { order: 1, icon: '🔧', label: 'Algemeen Handgereedschap', type: 'tools' },
    'Handgereedschap (Basis)': { order: 1, icon: '🔧', label: 'Algemeen Handgereedschap', type: 'tools' },
    '1. Basis Handgereedschap (Mechanisch)': { order: 1, icon: '🔧', label: 'Algemeen Handgereedschap', type: 'tools' },
    '🔧 Algemeen Handgereedschap': { order: 1, icon: '🔧', label: 'Algemeen Handgereedschap', type: 'tools' },

    // 2. Speciaal
    'Speciaal Gereedschap': { order: 2, icon: '🔩', label: 'Speciaal Gereedschap', type: 'tools' },
    '3. Specifiek & Zwaarder Gereedschap': { order: 2, icon: '🔩', label: 'Speciaal Gereedschap', type: 'tools' },
    '🔩 Speciaal Gereedschap': { order: 2, icon: '🔩', label: 'Speciaal Gereedschap', type: 'tools' },

    // 3. Elektrisch (Hand) / Power Tools
    '2. Elektrisch Gereedschap (Hand)': { order: 3, icon: '⚡', label: 'Elektrisch Gereedschap', type: 'tools' },
    'Power Tools': { order: 3, icon: '⚡', label: 'Elektrisch Gereedschap', type: 'tools' },
    '⚡ Elektrisch Gereedschap': { order: 3, icon: '⚡', label: 'Elektrisch Gereedschap', type: 'tools' },

    // 4. Pneumatiek
    '5. Pneumatiek / Hydrauliek Gereedschap': { order: 4, icon: '💨', label: 'Pneumatiek / Hydrauliek', type: 'tools' },
    '💨 Pneumatiek / Hydrauliek': { order: 4, icon: '💨', label: 'Pneumatiek / Hydrauliek', type: 'tools' },

    // 5. Elektro & Fijn
    'Elektro (V-1000) & Fijn': { order: 5, icon: '🔌', label: 'Elektro & Fijn', type: 'tools' },
    '⚡ Elektro & Fijn': { order: 5, icon: '⚡', label: 'Elektro & Fijn', type: 'tools' },

    // 6. Meten
    'Meetgereedschap': { order: 6, icon: '📐', label: 'Meetgereedschap', type: 'tools' },
    '4. Meet- en Diagnose-instrumenten': { order: 6, icon: '📐', label: 'Meetgereedschap', type: 'tools' },
    'Meten & Diagnose': { order: 6, icon: '📐', label: 'Meetgereedschap', type: 'tools' },
    '📐 Meetgereedschap': { order: 6, icon: '📐', label: 'Meetgereedschap', type: 'tools' },

    // 7. Werkplaats & Klimmen
    'Werkplaats & Klimmen': { order: 7, icon: '🪜', label: 'Werkplaats & Klimmen', type: 'tools' },
    '🪜 Werkplaats & Klimmen': { order: 7, icon: '🪜', label: 'Werkplaats & Klimmen', type: 'tools' },

    // 8. Grote Machines
    '6. Elektrisch (Groot) en Machines': { order: 8, icon: '🏗️', label: 'Grote Machines', type: 'tools' },
    '🏗️ Grote Machines': { order: 8, icon: '🏗️', label: 'Grote Machines', type: 'tools' },

    // 9. Licht & Zicht
    'Licht & Zicht': { order: 9, icon: '💡', label: 'Licht & Zicht', type: 'tools' },
    '💡 Licht & Zicht': { order: 9, icon: '💡', label: 'Licht & Zicht', type: 'tools' },

    // 10. Grijpvoorraad
    'Grijpvoorraad': { order: 10, icon: '📦', label: 'Grijpvoorraad', type: 'tools' },
    '📦 Grijpvoorraad': { order: 10, icon: '📦', label: 'Grijpvoorraad', type: 'tools' },

    // 11. IT & Administratie
    'IT & Administratie': { order: 11, icon: '💻', label: 'IT & Administratie', type: 'tools' },
    '💻 IT & Administratie': { order: 11, icon: '💻', label: 'IT & Administratie', type: 'tools' },

    // 12. Schoonmaak
    'Schoonmaak': { order: 12, icon: '🧽', label: 'Schoonmaak', type: 'tools' },
    '🧽 Schoonmaak': { order: 12, icon: '🧽', label: 'Schoonmaak', type: 'tools' },


    // --- PPEs (PBM) ---
    // 1. Algemeen
    'PBM & Veiligheid': { order: 1, icon: '🛡️', label: 'PBM & Veiligheid', type: 'ppes' },
    '🛡️ PBM & Veiligheid': { order: 1, icon: '🛡️', label: 'PBM & Veiligheid', type: 'ppes' },

    // 2. Oog/Gelaat
    'Gelaats- en Oogbescherming': { order: 2, icon: '👓', label: 'Gelaats- en Oogbescherming', type: 'ppes' },
    'Gelaats- en Oogbescherming (Verhoogd Risico)': { order: 2, icon: '👓', label: 'Gelaats- en Oogbescherming', type: 'ppes' },
    '👓 Gelaats- en Oogbescherming (Verhoogd Risico)': { order: 2, icon: '👓', label: 'Gelaats- en Oogbescherming', type: 'ppes' },

    // 3. Handen
    'Handbescherming': { order: 3, icon: '🧤', label: 'Handbescherming', type: 'ppes' },
    'Handbescherming (Taakspecifiek)': { order: 3, icon: '🧤', label: 'Handbescherming', type: 'ppes' },
    '🧤 Handbescherming (Taakspecifiek)': { order: 3, icon: '🧤', label: 'Handbescherming', type: 'ppes' },

    // 4. Hoofd
    'Hoofdbescherming': { order: 4, icon: '⛑️', label: 'Hoofdbescherming', type: 'ppes' },
    'Hoofdbescherming (Taakspecifiek)': { order: 4, icon: '⛑️', label: 'Hoofdbescherming', type: 'ppes' },
    '⛑️ Hoofdbescherming (Taakspecifiek)': { order: 4, icon: '⛑️', label: 'Hoofdbescherming', type: 'ppes' },

    // 5. Lichaam
    'Lichaamsbescherming': { order: 5, icon: '🦺', label: 'Lichaamsbescherming', type: 'ppes' },
    'Lichaamsbescherming (Taakspecifiek)': { order: 5, icon: '🦺', label: 'Lichaamsbescherming', type: 'ppes' },
    '🦺 Lichaamsbescherming (Taakspecifiek)': { order: 5, icon: '🦺', label: 'Lichaamsbescherming', type: 'ppes' },

    // 6. Val
    'Bescherming tegen Vallen': { order: 6, icon: '🪢', label: 'Bescherming tegen Vallen', type: 'ppes' },
    '🪢 Bescherming tegen Vallen': { order: 6, icon: '🪢', label: 'Bescherming tegen Vallen', type: 'ppes' },

    // 7. Adem
    'Adembescherming': { order: 7, icon: '😷', label: 'Adembescherming', type: 'ppes' },
    '😷 Adembescherming': { order: 7, icon: '😷', label: 'Adembescherming', type: 'ppes' },

    // 8. Gas
    'Bescherming tegen Gas': { order: 8, icon: '🧪', label: 'Bescherming tegen Gas', type: 'ppes' },
    '🧪 Bescherming tegen Gas': { order: 8, icon: '🧪', label: 'Bescherming tegen Gas', type: 'ppes' }
};

// Helper: Robust Icon Stripper
export const stripIcons = (name) => {
    if (!name) return '';
    // 1. Definite list of icons we use
    const knownIcons = ['🔧', '🔩', '⚡', '💨', '🔌', '📐', '🪜', '🏗️', '💡', '📦', '💻', '🧽', '🛡️', '👓', '🧤', '⛑️', '🦺', '🪢', '😷', '🧪'];

    let cleaned = name;
    // Remove known icons
    knownIcons.forEach(icon => {
        cleaned = cleaned.split(icon).join('');
    });

    // Remove standard regex garbage
    cleaned = cleaned.replace(/^[0-9\.\s]+/, '')
        .replace(/^[\uD800-\uDBFF][\uDC00-\uDFFF]\s*/, '')
        .replace(/^\W+\s*/, '')
        .trim();

    return cleaned;
};

// Helper: Resolve Full Config Object by Category Name
export const getCategoryConfigObject = (categoryName) => {
    if (!categoryName) return null;
    if (typeof categoryName !== 'string') return null; // Prevention against crash

    // 1. Direct Match
    if (CATEGORY_CONFIG[categoryName]) return CATEGORY_CONFIG[categoryName];

    // 2. Strip standard icons and numbers to find match
    const stripped = categoryName.replace(/^[0-9\.\s]+/, '').replace(/^[\uD800-\uDBFF][\uDC00-\uDFFF]\s*/, '').trim();

    const matchKey = Object.keys(CATEGORY_CONFIG).find(key => {
        return categoryName.includes(key) || key.includes(stripped);
    });

    if (matchKey) return CATEGORY_CONFIG[matchKey];

    // 3. Keyword matching fallbacks
    const lower = categoryName.toLowerCase();

    // Tools Logic
    if (lower.includes('handgereedschap')) return CATEGORY_CONFIG['Algemeen Handgereedschap'];
    if (lower.includes('speciaal')) return CATEGORY_CONFIG['Speciaal Gereedschap'];
    if (lower.includes('elektrisch') && lower.includes('hand')) return CATEGORY_CONFIG['2. Elektrisch Gereedschap (Hand)'];
    if (lower.includes('power')) return CATEGORY_CONFIG['Power Tools'];
    if (lower.includes('pneumatiek')) return CATEGORY_CONFIG['5. Pneumatiek / Hydrauliek Gereedschap'];
    if (lower.includes('elektro') && lower.includes('fijn')) return CATEGORY_CONFIG['Elektro (V-1000) & Fijn'];
    if (lower.includes('meet')) return CATEGORY_CONFIG['Meetgereedschap'];
    if (lower.includes('werkplaats')) return CATEGORY_CONFIG['Werkplaats & Klimmen'];
    if (lower.includes('grote')) return CATEGORY_CONFIG['6. Elektrisch (Groot) en Machines'];
    if (lower.includes('licht')) return CATEGORY_CONFIG['Licht & Zicht'];
    if (lower.includes('grijp')) return CATEGORY_CONFIG['Grijpvoorraad'];
    if (lower.includes('it')) return CATEGORY_CONFIG['IT & Administratie'];
    if (lower.includes('schoonmaak')) return CATEGORY_CONFIG['Schoonmaak'];

    // PPE Logic
    if (lower.includes('pbm')) return CATEGORY_CONFIG['PBM & Veiligheid'];
    if (lower.includes('gelaat') || lower.includes('oog')) return CATEGORY_CONFIG['Gelaats- en Oogbescherming'];
    if (lower.includes('hand') && lower.includes('bescherming')) return CATEGORY_CONFIG['Handbescherming'];
    if (lower.includes('hoofd')) return CATEGORY_CONFIG['Hoofdbescherming'];
    if (lower.includes('lichaam')) return CATEGORY_CONFIG['Lichaamsbescherming'];
    if (lower.includes('val')) return CATEGORY_CONFIG['Bescherming tegen Vallen'];
    if (lower.includes('adem')) return CATEGORY_CONFIG['Adembescherming'];
    if (lower.includes('gas')) return CATEGORY_CONFIG['Bescherming tegen Gas'];

    return null;
};

// Helper: Get Icon by Category Name (Robust)
export const getCategoryIcon = (categoryName) => {
    const config = getCategoryConfigObject(categoryName);
    return config ? config.icon : '📂';
};

// Helper: Get Order by Category Name
export const getCategoryOrder = (categoryName) => {
    const config = getCategoryConfigObject(categoryName);
    return config ? config.order : 999;
};

// Helper: Sort Items by Category Order then Name
export const sortItems = (items) => {
    if (!items) return [];
    return [...items].sort((a, b) => {
        const catA = typeof a === 'string' ? 'Overig' : a.category;
        const catB = typeof b === 'string' ? 'Overig' : b.category;

        const orderA = getCategoryOrder(catA);
        const orderB = getCategoryOrder(catB);

        if (orderA !== orderB) return orderA - orderB;

        const nameA = typeof a === 'string' ? stripIcons(a) : stripIcons(a.name);
        const nameB = typeof b === 'string' ? stripIcons(b) : stripIcons(b.name);
        return nameA.localeCompare(nameB);
    });
};
